import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Button from '@material-ui/core/Button';
import Popover from './Popover';
import LinearProgress from '@material-ui/core/LinearProgress';
import { unstable_useMediaQuery as useMediaQuery } from '@material-ui/core/useMediaQuery';


const styles = theme => ({
  root: {
     display: 'flex',
     flexWrap: 'wrap',
     justifyContent: 'space-around',
     overflow: 'hidden',

  },
  linearColorPrimary: {
   backgroundColor: '#b2dfdb',
 },
 linearBarColorPrimary: {
   backgroundColor: '#00695c',
 },
  gridList: {
  width: '70vw',
  height: '21em',
  padding: '2%',

    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    // transform: 'translateZ(0)',
  },


});

const PhotoScroll = ({loading, classes,id, tileData, handleClickOpen, handleClose,open, popData}) => (
  <div className={classes.root}>
      <GridList className={classes.gridList}  cols={ useMediaQuery('(max-width:600px)') ? 1 : 3}>

        {loading ?
          <LinearProgress
            classes={{
              colorPrimary: classes.linearColorPrimary,
              barColorPrimary: classes.linearBarColorPrimary,
            }}
          />
          :
          tileData.map(tile => (
          <GridListTile key={tile.id} padding={20} className='gridItems'>
              <img src={tile.img} alt={tile.title} id={tile.id} onClick={handleClickOpen} className='imghover'/>
          </GridListTile>


        ))}
        <Popover
          open={open}
          handleClose={handleClose}
          popData={popData}

          />

      </GridList>
    </div>
)

export default withStyles(styles)(PhotoScroll)
